export const initDropdownNavs = () => {
	const els = document.querySelectorAll('.js-dropdown-nav');
	for (const el of els)
		initDropdownNav(el);
};

/**
 * Initializes a dropdown navigation form component.
 * @param {HTMLFormElement} el - Dropdown navigation form element
 */
const initDropdownNav = (el) => {
	const selectEl = el.querySelector('select');
	if (!selectEl)
		throw new Error('Missing dropdown nav select box element');

	/**
	 * Handles the form submission.
	 * @param {SubmitEvent} ev - Submit event
	 * @type {EventListener}
	 */
	const handleSubmit = (ev) => {
		ev.preventDefault();

		const fd = new FormData(el);

		const destination = fd.get('destination');
		if (!destination || typeof destination !== 'string')
			return;

		location.href = destination;
	};

	/**
	 * Enables submit button and styling when item has been selected.
	 * @type {EventListener}
	 */
	const handleChange = () => {
		if (!selectEl.value)
			return;

		selectEl.nextElementSibling.removeAttribute("disabled");
		selectEl.parentElement.classList.add('is-active');
	};

	el.addEventListener('submit', handleSubmit);
	selectEl.addEventListener('change', handleChange);
};

